import { forwardRef } from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import {
  TABS_DEFAULTS,
  TABS_VARIANT_CLASS_MAP,
  type TTabsTriggerElement,
  type TTabsTriggerProps,
} from "@/ui/components/navigation/Tabs/Tabs.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { cn } from "@/ui/lib/utils";
import { TextBody } from "@/ui/components/typography/TextBody";
import { TextControl } from "@/ui/components/typography/TextControl";

export const TabsTrigger = forwardRef<TTabsTriggerElement, TTabsTriggerProps>(
  (
    {
      className,
      variant = TABS_DEFAULTS.variant,
      description,
      children,
      icon,
      ...props
    },
    ref,
  ) => (
    <TabsPrimitive.Trigger
      data-component="TabsTrigger"
      ref={ref}
      className={cn(
        "px-2 py-1 flex justify-center items-center flex-col space-y-1",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary",
        TABS_VARIANT_CLASS_MAP[variant].trigger,
        className,
      )}
      {...props}
    >
      { variant === "icon" && icon ? <Icon icon={icon} size="lg" /> : null }
      <TextControl
        tag="span"
        size={2}
        isResponsive={false}
        color="inherit"
        align="center"
        whitespace="noWrap"
        className={TABS_VARIANT_CLASS_MAP[variant].label}
      >{ children }</TextControl>
      { description ? (
        <TextBody tag="span" size={3} isResponsive={false} color="inherit" align="center">{ description }</TextBody>
      ): null }
    </TabsPrimitive.Trigger>
  ),
);

TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
